<div
  class="product-card flex h-full justify-between px-5 py-3 leading-5 md:px-3 xl:px-5 xl:py-5 transition-colors duration-150 rounded-none md:rounded-lg"
  [class.opacity-40]="!isAvailable || !isOrderingAllowed()"
  [class.cursor-pointer]="isAvailable && isOrderingAllowed()"
  (click)="goToProduct(product())"
>
  <div class="w-full overflow-hidden pr-5">
    <p class="font-bold">
      @if (product()[ProductKeys.Quantity]) {
        <span
          class="notranslate mr-2 inline-block rounded-xm bg-primary-600 px-2 text-sm text-white"
        >
          {{ product()[ProductKeys.Quantity] }}×
        </span>
      }
    </p>
    <p
      class="product-name xl:texit-md break-words font-accent text-base font-bold"
      [style.color]="productNameColor() | contentBuilderColor: defaultProductNameColor"
    >
      {{ product()[ProductKeys.Name] }}
    </p>
    @if (product()[ProductKeys.Description]) {
      <p
        class="product-description line-clamp-2 pt-0.5 font-base text-sm xl:pt-1.5"
        [style.color]="
          productDescriptionColor() | contentBuilderColor: defaultProductDescriptionColor
        "
      >
        {{ product()[ProductKeys.Description] | firstLine }}
      </p>
    }

    @let visibleLabels = productLabels | appVisibleLabels;
    @if (visibleLabels?.length || !isAvailable) {
      <ul class="mt-2 flex flex-wrap gap-1 xl:mt-3">
        @if (!isAvailable) {
          <li>
            <app-tag-atom
              [bold]="false"
              color="neutral"
              [text]="'product-add-modal.product-unavailable' | translate"
            ></app-tag-atom>
          </li>
        }
        @for (label of visibleLabels; track label) {
          <li>
            <app-tag-atom
              [bold]="false"
              [text]="label.name"
              [lineThrough]="label.line_through"
            ></app-tag-atom>
          </li>
        }
      </ul>
    }
    @if (!product()[ProductKeys.PriceToDisplay]) {
      <div class="product-price mt-2 flex flex-row gap-2 text-sm xl:mt-3">
        @if (displayDiscount(product())) {
          <app-price-atom
            class="mr-1"
            [amount]="product()[ProductKeys.Discount] ?? 0"
            [discount]="_hasDiscountPromotionLabel()"
            [bold]="false"
          ></app-price-atom>
          @if (product()[ProductKeys.Price]) {
            <app-tag-atom
              class="mr-1"
              color="success"
              [lineThrough]="_hasDiscountPromotionLabel()"
              [text]="
                product()[ProductKeys.Price] | discountPercent: product()[ProductKeys.Discount] ?? 0
              "
            ></app-tag-atom>
          }
          @if (product()[ProductKeys.Price]) {
            <app-price-atom
              class="mr-1"
              [amount]="product()[ProductKeys.Price]"
              [discount]="true"
              [bold]="false"
            ></app-price-atom>
          }
        } @else {
          <app-price-atom
            class="mr-1"
            [amount]="product()[ProductKeys.Price]"
            [discount]="_hasDiscountPromotionLabel()"
            [bold]="false"
          ></app-price-atom>
        }
      </div>
    }
    @if (product()[ProductKeys.PriceToDisplay]) {
      <div class="product-price mt-2 text-base xl:mt-3 xl:text-md">
        <span class="notranslate mr-1"> {{ product()[ProductKeys.PriceToDisplay] }}</span>
      </div>
    }
  </div>
  <div
    class="push-image relative h-full overflow-hidden rounded-lg object-cover"
    [style.backgroundColor]="
      productImagePlaceholderColor() | contentBuilderColor: defaultProductImagePlaceholderColor
    "
  >
    @if (quantityInCart() > 0) {
      <span
        class="notranslate absolute right-2 top-2 z-1 inline-flex h-6 min-w-6 items-center justify-center rounded-full bg-primary-600 px-1.5 text-xs font-bold text-white"
      >
        {{ quantityInCart() }}
      </span>
    }
    @if (product().images?.thumbnail?.url) {
      <img
        class="push-image h-full rounded object-cover"
        [src]="product().images?.thumbnail?.url"
        alt="image"
      />
    }
  </div>
</div>
